
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(4(01|38|49|55|69|74)|1(2|34|6)|96(|9)|03|041|207|302|399|561|725)|2((02|04|58)0|(14|31|7)3|25|341|476|517|609|685|808)|5(70[14]|3(39|46|96)|068|189|265|903)|6(2(11|69|76)|76[04]|001|058|138|369|602|642|83)|1(7(24|52|73)|[25]62|064|160|328|416|547|981)|8(8(46|58|6)|262|419|579|681)|7(091|110|157|218|614|852)|3((10|34|63)2|085|276|297|313|49|575|671|989|998)|9(7(0|59|61)|(38|85|89)0|(02|35|53)3|034|138|172|269|435))$/.test(chunkId);
},
rootOutputDir: "",

    };
}
